import React, { createContext, useState, useContext } from "react";
export const CookieConsentContext = createContext();
export const useCookieConsent = () => useContext(CookieConsentContext);

export function CookieConsentProvider({ children }) {
  const [showPreferencesModal, setShowPreferencesModal] = useState(false);
  const openPreferencesModal = () => setShowPreferencesModal(true);
  const closePreferencesModal = () => setShowPreferencesModal(false);

  return (
    <CookieConsentContext.Provider value={{
      showPreferencesModal,
      openPreferencesModal,
      closePreferencesModal
    }}>
      {children}
    </CookieConsentContext.Provider>
  );
}
